import { controls,grouped } from "../controls";
const cash_2observations = {
label: "Cash 2observations",
pageLabel: "Cash 2observations",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Cash Balance"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "cash_balance",maxlength:18}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Date",target: "date",star:false}),
...controls.magicDate({ tab: "general", name: "date", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Time",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "time",isRequired:false,maxlength:30}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Token Register Number",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "token_register_number",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Token Book Number",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "token_book_number",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Duplicate key deposited on",target: "duplicate_key",star:false}),
...controls.magicDate({ tab: "general", name: "duplicate_key", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "is key movement register is tallied with attendance register and detail memo",default:false, name: "boolean_1",width:"col-sm-7" }),
...controls.displayText({ tab: "general", label: "",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "observation1",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "is cash remittance register signed by cashier and branch manager",default:false, name: "boolean_2",width:"col-sm-7" }),
...controls.displayText({ tab: "general", label: "",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "observation2",isRequired:false,maxlength:50,width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "is cash in hand signed by cashier and branch manager in cash book and cash memo",default:false, name: "boolean_3",width:"col-sm-7" }),
...controls.displayText({ tab: "general", label: "",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "observation3",isRequired:false,maxlength:50,width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "is cash limit fixed by ho",default:false, name: "boolean_4",width:"col-sm-7" }),
...controls.displayText({ tab: "general", label: "",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "observation4",isRequired:false,maxlength:50,width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "is cash held within prescribed limits",default:false, name: "boolean_5",width:"col-sm-7" }),
...controls.displayText({ tab: "general", label: "",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "observation5",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "is gun licence renewed",default:false, name: "boolean_6",width:"col-sm-7" }),
...controls.displayText({ tab: "general", label: "",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "observation6",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "is alram system in working condition",default:false, name: "boolean_7",width:"col-sm-7" }),
...controls.displayText({ tab: "general", label: "",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "observation7",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "is dark recipt register properly maintained",default:false, name: "boolean_8",width:"col-sm-7" }),
...controls.displayText({ tab: "general", label: "",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "observation8",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "is surprise verification of cash is being done by head office perodically",default:false, name: "boolean_9",width:"col-sm-7" }),
...controls.displayText({ tab: "general", label: "",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "observation9",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "is insurance policy for cash taken",default:false, name: "boolean_10",width:"col-sm-7" }),
...controls.displayText({ tab: "general", label: "",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "observation10",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
]
,history:{
perPage: 10,
reportHeader: "Cash 2observations",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Cash Balance",accessor: "cash_balance",},
{Header: "Date",accessor: "date",type:'date'},
{Header: "Time",accessor: "time",},
{Header: "Token Register Number",accessor: "token_register_number",},
{Header: "Token Book Number",accessor: "token_book_number",},
{Header: "is key movement register is tallied with attendance register and detail memo",accessor: "boolean_1",type:'tick'},
{Header: "",accessor: "observation1",},
]}};
export default cash_2observations;